exports = module.exports = require("../../../../../home/g0/live-stream/web-client/node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n#app[data-v-3f1f4b78] {\n  -webkit-box-flex: 1;\n  -webkit-flex: 1;\n      -ms-flex: 1;\n          flex: 1;\n  height: 100%;\n}\n", "", {"version":3,"sources":["/builds/unisdk-web/live-stream/client/src/App.vue"],"names":[],"mappings":";AACA;EACE,oBAAoB;EACpB,gBAAgB;MACZ,YAAY;UACR,QAAQ;EAChB,aAAa;CACd","file":"App.vue","sourcesContent":["\n#app[data-v-3f1f4b78] {\n  -webkit-box-flex: 1;\n  -webkit-flex: 1;\n      -ms-flex: 1;\n          flex: 1;\n  height: 100%;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// /home/g0/live-stream/web-client/node_modules/css-loader?{"sourceMap":true}!/home/g0/live-stream/web-client/node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3f1f4b78","scoped":true,"hasInlineConfig":false}!/home/g0/live-stream/web-client/node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!/home/g0/live-stream/web-client/node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/App.vue
// module id = ryyp
// module chunks = 5 6 7 8